var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSortTriangle = function SvgSortTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    fillRule: "evenodd",
    d: "M3.987 8.258a.44.44 0 0 1 .388-.235h5.25a.437.437 0 0 1 .36.687L7.36 12.502a.437.437 0 0 1-.72 0L4.015 8.71a.44.44 0 0 1-.028-.452m1.223.64h3.58zM7 1.313c.144 0 .278.07.36.188l2.625 3.792a.437.437 0 0 1-.36.686h-5.25a.437.437 0 0 1-.36-.686L6.64 1.5A.44.44 0 0 1 7 1.313M5.21 5.104h3.58-3.58",
    clipRule: "evenodd"
  })));
};
export default SvgSortTriangle;